<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    maxWidth="800"
    :title="modal.title"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-form class="mt-5">
      <tiptap-vuetify v-model="comment.text" :extensions="extensions" />

      <v-row align="center">
        <v-col class="text-center" cols="2">
          <v-text-field
            style="position:absolute"
            v-model="comment.pageNumber"
            min="1"
            type="number"
            v-bind:label="$t('Page')"
            :error-messages="pageNumberErrors"
            @input="$v.comment.pageNumber.$touch()"
            @blur="$v.comment.pageNumber.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </base-modal>
</template>

<script>
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from "tiptap-vuetify";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import CommentService from "@/services/CommentService";
import Comment from "@/ecm/models/search/results/list/Comment";
import Utils from "@/ecm/common/Utils";

export default {
  name: "CommentModal",
  components: {
    TiptapVuetify
  },
  data() {
    return {
      comment: new Comment(),
      modal: {
        title: this.$t("Comments"),
        key: "commentModal"
      },
      open: false,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3]
            }
          }
        ],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak
      ]
    };
  },
  mixins: [validationMixin],
  validations: {
    comment: {
      pageNumber: { required }
    }
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    pageNumberErrors() {
      const errors = [];
      if (!this.$v.comment.pageNumber.$dirty) return errors;
      !this.$v.comment.pageNumber.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    }
  },
  methods: {
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);

      CommentService.save(this.comment.toDto())
        .then(result => {
          if (result) {
            this.hide();
            this.$emit("on-comment-saved");
          }
        })
        .catch(error => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    new(documentId) {
      this.comment = new Comment();
      this.comment.pageNumber = 1;
      this.comment.documentId = documentId;
      this.$v.$reset();
      this.show();
    },
    edit(comment) {
      this.comment = Utils.object.clone(new Comment(), comment);
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    }
  }
};
</script>
